<template>
  <div id="app" :style="{ color: fontColor }">
    <Home />
    <Loading></Loading>
    <Toast></Toast>
    <OpenApp />
  </div>
</template>

<script>
import Toast from "@/components/Toast"
import Loading from "@/components/Loading"
import OpenApp from "@/components/OpenApp"
import Home from "./views/Home"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { mapMutations, mapGetters } from "vuex"

export default {
  name: "app",
  components: {
    Toast,
    Loading,
    OpenApp,
    Home
  },
  methods: {
    ...mapMutations({
      setActivityId: "activityInfo/setActivityId"
    }),
    redirectRoute({ routeName }) {
      this.$router.replace({ name: routeName, query: this.$route.query })
    },
    getUrlParams() {
      const params = getParamsFromUrl()
      if (params.id) {
        this.setActivityId(params.id)
      }
    },
    async init() {
      this.getUrlParams()
    }
  },
  computed: {
    ...mapGetters({
      fontColor: "activityInfo/fontColor"
    })
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: auto;
  background: #ffffff;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  letter-spacing: 0;
  text-align: justify;
  line-height: 22px;
  min-height: 100%;
}
html,
body {
  min-width: 1200px;
  max-width: 100%;
  height: auto;
  min-height: 100%;
}
</style>
